import RenderAttributeInput, { AttributeFieldProps } from "./RenderAttributeInput";
import GetAttributeDefinition, { AttributeInputType } from "../Data/WBData";

export default function ConditionalField(props:AttributeFieldProps){


    let shouldShow = props.definition.shouldShow(props.layoutObject);
        if(!shouldShow){
            return null;
        }
        else{
            let def = GetAttributeDefinition(props.definition.attKey);
            if(def.inputType != AttributeInputType.Conditional){
                let newProps = {...props,definition:def,label:def.label};
                return <RenderAttributeInput {...newProps}/>
            }
        }

        return null;
}